import { FilterGroup, SortDef } from './grid-types';

export interface GridViewState {
  visibleColumns: string[];
  pageSize: number;
  sort: SortDef[];
  filter: FilterGroup;
  colWidths: Record<string, number>;
}

const key = (gridKey: string) => `wcgrid:view:${gridKey}`;

export function loadView(gridKey: string, defaults: GridViewState): GridViewState {
  try {
    const raw = localStorage.getItem(key(gridKey));
    if (!raw) return defaults;
    const v = JSON.parse(raw) as GridViewState;
    return {
      visibleColumns: Array.isArray(v.visibleColumns) ? v.visibleColumns : defaults.visibleColumns,
      pageSize: typeof v.pageSize === 'number' ? v.pageSize : defaults.pageSize,
      sort: Array.isArray(v.sort) ? v.sort : defaults.sort,
      filter: v.filter ?? defaults.filter,
      colWidths: v.colWidths ?? defaults.colWidths
    };
  } catch {
    return defaults;
  }
}

export function saveView(gridKey: string, state: GridViewState) {
  localStorage.setItem(key(gridKey), JSON.stringify(state));
}

export function clearView(gridKey: string) {
  localStorage.removeItem(key(gridKey));
}
